<template>
    <div :style="attomStyle" class="attom-desc" v-html="html"></div>
</template>
<script>

export default {
    props: {
        content: {
            type: String,
            default: ''
        },
        size: {
            type: Number,
            default: 12
        },
        lineHeight: {
            type: Number,
            default: 16
        },
        color: {
            type: String,
            default: ''
        },
        linkColor: {
            type: String,
            default: ''
        },
        hasDot: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        attomStyle({ color, linkColor, size, lineHeight }) {
            let ret = { 'font-size': size + 'px',
                'line-height': lineHeight + 'px', }
            if (color) {
                ret['--g-text-color-dynamic'] = color
            }
            if (linkColor) {
                ret['--color-link-dynamic'] = linkColor
            }
            return ret
        },
        html({ content, hasDot }) {
            if (!content) {
                content = this.$t('common:attomDataDescription')  + (hasDot ? '.' : '')
            }
            return content
        }
    }
}
</script>
<style lang="scss">
.attom-desc {
	color: var(--g-text-color-dynamic, var(--g-text-color));
	a {
		color: var(--color-link-dynamic, var(--color-link));
		&:hover {
			text-decoration: underline;
		}
	}
}
</style>
